export default __webpack_public_path__ + "static/media/twitter.3e6e8557.svg";